import React, { useEffect, useState } from 'react';
import { Empty } from 'antd';
import { useTranslation } from 'react-i18next';
import { getNoteStateChange, getSelectedNote } from '../../hooks/useDashboardGlobalVar';

/**
 * 右侧内容面板组件 - 显示 KnowledgeCard
 */
const RightContentPane = ({
  selectedNote,
  children,
}) => {
  const { t } = useTranslation(['dashboard', 'common']);
  // 添加状态来强制重新渲染
  const [forceUpdate, setForceUpdate] = useState(0);
  // 监听笔记状态变化
  useEffect(() => {
    let lastNoteStateChange = null;
    
    const checkNoteStateChange = () => {
      const currentNoteStateChange = getNoteStateChange();
      
      // 检查是否有新的状态变化
      if (currentNoteStateChange && 
          currentNoteStateChange.timestamp && 
          (!lastNoteStateChange || currentNoteStateChange.timestamp > lastNoteStateChange.timestamp)) {
        
        lastNoteStateChange = currentNoteStateChange;
        console.log('[RightContentPane] 检测到笔记状态变化:', currentNoteStateChange);
        
        // 根据变化类型处理不同的刷新逻辑
        switch (currentNoteStateChange.changeType) {
          case 'pin':
          case 'unpin':
            // 置顶/取消置顶操作后，需要刷新笔记内容
            console.log('[RightContentPane] 笔记置顶状态变化，触发内容刷新');
            // 强制组件重新渲染以更新置顶图标
            setForceUpdate(prev => prev + 1);
            
            // 添加调试日志，显示当前笔记的置顶状态
            const currentNote = getSelectedNote();
            if (currentNote) {
              console.log('[RightContentPane] 当前笔记置顶状态:', {
                noteId: currentNote.id,
                isPinned: currentNote.is_pinned,
                title: currentNote.title
              });
            }
            break;
          case 'update':
            // 笔记更新后，刷新当前笔记内容
            console.log('[RightContentPane] 笔记内容更新，触发内容刷新');
            // 强制组件重新渲染以显示最新内容
            setForceUpdate(prev => prev + 1);
            break;
          case 'refresh':
            // 笔记刷新操作后，强制重新渲染
            console.log('[RightContentPane] 笔记刷新操作，触发内容刷新');
            setForceUpdate(prev => prev + 1);
            break;
          case 'delete':
            // 笔记删除后，清空内容显示
            console.log('[RightContentPane] 笔记删除，清空内容显示');
            break;
          default:
            console.log('[RightContentPane] 未知的笔记状态变化类型:', currentNoteStateChange.changeType);
        }
      }
    };
    
    // 设置定时器，每100ms检查一次笔记状态变化
    const intervalId = setInterval(checkNoteStateChange, 100);
    
    // 清理定时器
    return () => clearInterval(intervalId);
  }, []);
  // 检查 children 是否是 NoteListAsk 组件（通过检查 props 中的 embedded 属性）
  // 如果 children 是 NoteListAsk（embedded=true），不需要 selectedNote 检查，直接显示
  const isNoteListAsk = React.isValidElement(children) && children.props && children.props.embedded === true;
  
  return (
    <div className="preview-panel-content" style={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      
      {isNoteListAsk || selectedNote ? (
        <div className="note-preview-content" style={{ height: '100%', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
          {children}
        </div>
      ) : (
        <div className="empty-preview" style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Empty description={t('dashboard:select_card_to_view', { defaultValue: 'Select a card to view content' })} image={Empty.PRESENTED_IMAGE_SIMPLE} />
        </div>
      )}
    </div>
  );
};

export default RightContentPane; 